import React, { Component } from 'react'
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBContainer, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-duotone-svg-icons'
import { Link } from 'gatsby'

class NavBarPage extends Component {
    state = {
      collapsed: false,
    }

  handleTogglerClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  componentDidMount() {  
    const str = window.location.pathname.substr(1,window.location.pathname.length-1)
    const len = str.indexOf("/")
    this.setState({ 
      parentNav: len < 0 ? str : str.substr(0, len) 
    })
  }
  
 render() {
    const overlay = (
      <div
        id="sidenav-overlay"
        style={{ backgroundColor: 'transparent' }}
        onClick={this.handleTogglerClick}
      />
    )

    const isActive = ({ isCurrent }) => {
      return isCurrent ? { className: "nav-link active" } : {}
    }

    const isPartiallyActive = ({
      isPartiallyCurrent
    }) => {
      return isPartiallyCurrent
        ? { className: "nav-link active" }
        : {}
    }

    return (
      
      <div>
        <MDBNavbar
          color="top-nav-collapse"
          dark
          expand="lg"
          fixed="top"
          scrolling
          transparent
        >
          <MDBContainer>
            <MDBNavbarBrand>
              <Link to="/">
                <img
                  src="/eden-logo-we.svg"
                  alt="Company logo"
                  title="Eden"
                  height="45"
                />
              </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler aria-label="Mobile Navigation Button" onClick={this.handleTogglerClick} />
            <MDBCollapse isOpen={this.state.collapsed} navbar>
              <MDBNavbarNav right>
                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={this.state.parentNav === "real-estate" ? "active" : ""}>
                      <span className="mr-1">Real Estate</span> 
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-eden">
                      <MDBDropdownItem href="/real-estate/">Real Estate Development</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/unicom-science-and-technology-park/"> - UNICOM Science &amp; Technology Park</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/unicom-technology-park/"> - UNICOM Technology Park</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/unicom-innovation-park/"> - UNICOM Innovation Park</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/the-legendary-pickfair-estate/"> - Pickfair Estate</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/the-orangery/"> - The Orangery</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/crabbet-park/"> - Crabbet Park House</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/wingsweep/"> - Wingsweep</MDBDropdownItem>
                      <MDBDropdownItem href="/real-estate/roripaugh-ranch/"> - Roripaugh Ranch</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                <Link to="/business-financial-services/" getProps={isPartiallyActive} className="nav-link">Business &amp; Financial</Link>
                </MDBNavItem>
                <MDBNavItem>
                  <Link to="/mergers-acquisitions/" getProps={isPartiallyActive} className="nav-link">Mergers &amp; Acquisitions</Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                  <MDBDropdownToggle nav caret className={ (this.state.parentNav === 'about' || this.state.parentNav === 'contact' || this.state.parentNav === 'leadership' || this.state.parentNav === 'news') ? 'active' : '' }>
                      <span className="mr-1">Company</span> 
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-eden">
                      <MDBDropdownItem href="/contact/">Contact Us</MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/news/">Newsroom</MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/about/">About Us</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                <Link to="/search/" className="nav-link d-none d-lg-block" aria-label="Search">
                    <FontAwesomeIcon icon={faSearch} />
                  </Link>
                  <Link to="/search/" className="nav-link d-lg-none d-sm-block" aria-label="Search">
                    Search
                  </Link>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        {this.state.collapsed && overlay}
      </div>

)
}
}

export default NavBarPage
